__webpack_require__.p = "https://static.parastorage.com/services/restaurants-orders-ooi/f7f5293f8f449a4330a501e18abbc11a14f78771672fff26bd27eaaa/";